<template>
  <div class="static-page">
    <main class="mx-auto max-w-screen-xl px-4 py-12">
      <div class="flex flex-col items-center justify-center max-w-4xl mx-auto mt-24">
        <h1 class="gradient-title text-gray-900 dark:text-white">
          {{ store.systemConfigs.pricing_meta_title }}
        </h1>
        <div class="text-lg lg:text-xl mt-4 text-center text-gray-800 dark:text-gray-300">
          {{ store.systemConfigs.pricing_meta_description }}
        </div>
      </div>

      <PricingCards full />
    </main>
  </div>
</template>

<script setup lang="ts">
  import { useStore } from '$/stores/index.js'
  import PricingCards from '&/landing_pages/PricingCards.vue'

  const store = useStore()
</script>
